import { useState } from "react";
import { api } from "@/lib/api";

const VALIDATION_ERROR =
    "Please share your name, a way to reach you (email or phone), and a quick note.";
const NETWORK_ERROR =
    "Couldn't send your message. Please call 281.547.8447 or email info@crossroadstochange.com.";

/**
 * Encapsulates the handoff form state, validation and submit to /api/contact.
 * Returns the state, field setters, and a `submit` function bound to onSubmitted.
 */
export default function useHandoffForm({ defaultName, onSubmitted }) {
    const [name, setName] = useState(defaultName || "");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const isValid = () =>
        name.trim() && (email.trim() || phone.trim()) && message.trim();

    const submit = async (e) => {
        e.preventDefault();
        if (!isValid()) {
            setError(VALIDATION_ERROR);
            return;
        }
        setError("");
        setSubmitting(true);
        try {
            await api.post("/contact", {
                name: name.trim(),
                email: email.trim() || "noreply@crossroadstochange.com",
                phone: phone.trim() || null,
                subject: `Chat handoff via Jerry — ${name.trim()}`,
                message: message.trim(),
            });
            setDone(true);
            setTimeout(() => onSubmitted({ name: name.trim() }), 1100);
        } catch {
            setError(NETWORK_ERROR);
        } finally {
            setSubmitting(false);
        }
    };

    return {
        name, setName,
        email, setEmail,
        phone, setPhone,
        message, setMessage,
        submitting, done, error,
        submit,
    };
}
